import { render } from "./ModalMessage.vue?vue&type=template&id=f9cb4fcc"
import script from "./ModalMessage.vue?vue&type=script&lang=js"
export * from "./ModalMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__